import _ from 'lodash'
import type from './type'

export default ({ options, form }) =>
  _.find(options, {
    value: type({
      formikProps: form,
    }),
  })
